<template>
  <v-app>
    <v-system-bar app color="primary bar-z-top" height="12"></v-system-bar>

    <!-- Navbar -->
    <v-app-bar app color="secondary" class="hidden-md-and-down">
      <!--Traduzir o title do logo ips -->
      <v-img
        :alt="$t('ImgAltLogoIPS')"
        src="@/assets/LogoIPS.jpg"
        height="60px"
        width="0px"
        position="center"
        contain
        @click="$router.push({ name: 'Home' })"
        style="cursor: pointer"
      />
      <v-img
        :alt="$t('title')"
        src="@/assets/Logo_volutariado.png"
        height="45px"
        width="200px"
        position="left"
        contain
        @click="$router.push({ name: 'Home' })"
        style="cursor: pointer"
      />

      <v-select
        v-model="selectedLanguage"
        :items="availableLanguages"
        :label="$t('texts.language')"
        prepend-icon="mdi-translate"
        class="language"
        hide-details
        dense
        outlined
        style="width:75px"
      ></v-select>

      <v-spacer></v-spacer>

      <v-toolbar-items>
        <v-btn text active-class="btn-active" :to="{ name: 'Home' }">{{
          $t("texts.home")
        }}</v-btn>
        <v-btn text active-class="btn-active" :to="{ name: 'AboutUs' }">{{
          $t("texts.about")
        }}</v-btn>
        <v-btn text active-class="btn-active" :to="{ name: 'Volunteering' }">{{
          $t("texts.actions")
        }}</v-btn>
        <v-btn text active-class="btn-active" :to="{ name: 'Donation' }">{{
          $t("texts.donations")
        }}</v-btn>
        <v-btn
          v-if="
            $store.getters['Auth/isAuthenticated'] &&
              $store.getters['Auth/getUser']['type'] === 1
          "
          text
          active-class="btn-active"
          :to="{ name: 'Statistics' }"
          >{{ $t("texts.statistics") }}</v-btn
        >
      </v-toolbar-items>

      <v-divider class="thick" inset vertical />

      <v-btn
        v-if="!$store.getters['Auth/isAuthenticated']"
        text
        @click.stop="$store.dispatch('Util/showAuthLoginDialog')"
        >{{ $t("texts.loginregister") }}
        <v-icon right size="24">mdi-account</v-icon>
      </v-btn>
      <v-menu
        v-if="$store.getters['Auth/isAuthenticated']"
        bottom
        open-on-hover
        offset-y
        transition="slide-y-transition"
      >
        <template v-slot:activator="{ on }">
          <v-btn text v-on="on">
            {{ $store.getters["Auth/getUser"]["name"] }}
            <v-icon right size="24">mdi-account</v-icon>
          </v-btn>
        </template>

        <v-list>
          <v-list-item dense link :to="{ name: 'Profile' }">
            <v-list-item-icon>
              <v-icon>mdi-account</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ $t("texts.profile") }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item
            dense
            link
            @click.stop="$store.dispatch('Util/showChangePasswordDialog')"
          >
            <v-list-item-icon>
              <v-icon>mdi-lock</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{
                $t("texts.changepassowrd")
              }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item
            v-if="$store.getters['Auth/getUser']['type'] === 1"
            dense
            link
            :to="{ name: 'MyVolunteerings' }"
          >
            <v-list-item-icon>
              <v-icon>mdi-human-handsup</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{
                $t("texts.myvolunteeringsmenu")
              }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item
            v-if="[2, 3].includes($store.getters['Auth/getUser']['type'])"
            dense
            link
            @click="goToBackoffice"
          >
            <v-list-item-icon>
              <v-icon>mdi-cog</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{
                $t("texts.Registerinitiatives")
              }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item
            v-if="$store.getters['Auth/getUser']['type'] == 4"
            dense
            link
            @click="goToBackoffice"
          >
            <v-list-item-icon>
              <v-icon>mdi-cog</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{
                $t("texts.backoffice")
              }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item dense link @click="logout">
            <v-list-item-icon>
              <v-icon>mdi-exit-to-app</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ $t("texts.exit") }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-app-bar>
    <!-- !Navbar -->

    <!-- Navbar Mobile -->
    <v-app-bar app color="secondary" class="hidden-lg-and-up bar-z-top">
      <v-toolbar-title style="display: flex;">
        <v-img
          :alt="$t('ImgAltLogoIPS')"
          src="@/assets/LogoIPS.jpg"
          height="100px"
          width="80px"
          position="left"
          contain
          @click="$router.push({ name: 'Home' })"
          style="cursor: pointer"
        />
        <v-img
          :alt="$t('title')"
          src="@/assets/Logo_volutariado.png"
          height="100px"
          width="200px"
          position="left"
          contain
          @click="$router.push({ name: 'Home' })"
          style="cursor: pointer"
        />
      </v-toolbar-title>
      <v-spacer></v-spacer>

      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
    </v-app-bar>
    <v-navigation-drawer
      v-model="drawer"
      app
      temporary
      class="mobile-navigation-menu"
    >
      <v-list nav dense subheader>
        <v-subheader>{{ $t("texts.navigation") }}</v-subheader>

        <v-list-item-group color="primary">
          <v-list-item :to="{ name: 'Home' }">
            <v-list-item-content>
              <v-list-item-title>{{ $t("texts.home") }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item :to="{ name: 'AboutUs' }">
            <v-list-item-content>
              <v-list-item-title>{{ $t("texts.about") }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item :to="{ name: 'Volunteering' }">
            <v-list-item-content>
              <v-list-item-title>{{ $t("texts.actions") }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item :to="{ name: 'Donation' }">
            <v-list-item-content>
              <v-list-item-title>{{ $t("texts.donations") }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item
            v-if="
              $store.getters['Auth/isAuthenticated'] &&
                $store.getters['Auth/getUser']['type'] === 1
            "
            :to="{ name: 'Statistics' }"
          >
            <v-list-item-content>
              <v-list-item-title>{{
                $t("texts.statistics")
              }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
      </v-list>

      <v-divider></v-divider>

      <v-list nav dense>
        <!-- Non authenticated user -->
        <v-list-item
          v-if="!$store.getters['Auth/isAuthenticated']"
          @click.stop="$store.dispatch('Util/showAuthLoginDialog')"
        >
          <v-list-item-icon>
            <v-icon right size="24">mdi-account</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{
              $t("texts.loginregister")
            }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <!-- !Non authenticated user -->

        <!-- Aauthenticated user -->
        <v-list-group
          v-if="$store.getters['Auth/isAuthenticated']"
          prepend-icon="mdi-account"
          no-action
        >
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title>
                {{ $store.getters["Auth/getUser"]["name"] }}
              </v-list-item-title>
            </v-list-item-content>
          </template>

          <v-list-item :to="{ name: 'Profile' }">
            <v-list-item-content>
              <v-list-item-title>{{ $t("texts.profile") }}</v-list-item-title>
            </v-list-item-content>
            <v-list-item-icon>
              <v-icon>mdi-account</v-icon>
            </v-list-item-icon>
          </v-list-item>
          <v-list-item
            @click.stop="$store.dispatch('Util/showChangePasswordDialog')"
          >
            <v-list-item-content>
              <v-list-item-title>{{
                $t("texts.changepassowrd")
              }}</v-list-item-title>
            </v-list-item-content>
            <v-list-item-icon>
              <v-icon>mdi-lock</v-icon>
            </v-list-item-icon>
          </v-list-item>
          <v-list-item
            v-if="$store.getters['Auth/getUser']['type'] === 1"
            :to="{ name: 'MyVolunteerings' }"
          >
            <v-list-item-content>
              <v-list-item-title>{{
                $t("texts.myvolunteeringsmenu")
              }}</v-list-item-title>
            </v-list-item-content>
            <v-list-item-icon>
              <v-icon>mdi-human-handsup</v-icon>
            </v-list-item-icon>
          </v-list-item>
          <v-list-item
            v-if="$store.getters['Auth/getUser']['type'] > 1"
            @click="goToBackoffice"
          >
            <v-list-item-content>
              <v-list-item-title>
                {{ $t("texts.backoffice") }}
              </v-list-item-title>
            </v-list-item-content>
            <v-list-item-icon>
              <v-icon>mdi-cog</v-icon>
            </v-list-item-icon>
          </v-list-item>
          <v-list-item @click="logout">
            <v-list-item-content>
              <v-list-item-title>{{ $t("texts.exit") }}</v-list-item-title>
            </v-list-item-content>
            <v-list-item-icon>
              <v-icon>mdi-exit-to-app</v-icon>
            </v-list-item-icon>
          </v-list-item>
        </v-list-group>
        <!-- !Authenticated user -->
      </v-list>

      <template v-slot:append>
        <v-select
          v-model="selectedLanguage"
          :items="availableLanguages"
          :label="$t('texts.language')"
          prepend-icon="mdi-translate"
          class="ma-4"
          hide-details
          dense
          outlined
        ></v-select>

        <div class="pa-2 caption text-center">
          {{ $t("texts.copyright", { year: new Date().getFullYear() }) }}
        </div>
      </template>
    </v-navigation-drawer>
    <!-- !Navbar Mobile -->

    <!-- Application Content -->
    <!-- Sizes your content based upon application components -->
    <v-main>
      <!-- Provides the application the proper gutter -->
      <v-container>
        <router-view></router-view>
      </v-container>
    </v-main>
    <!-- !Application Content -->

    <!-- Footer -->
    <v-footer
      app
      color="accent primary--text"
      class="a-footer hidden-md-and-down"
    >
      <v-row no-gutters>
        <v-col cols="12" class="text-center">
          {{ $t("texts.copyright", { year: new Date().getFullYear() }) }}
        </v-col>
      </v-row>
    </v-footer>
    <!-- !Footer -->

    <!-- Login/Register Dialog -->
    <v-dialog
      v-model="$store.getters['Util/getAuthLoginDialog']"
      width="1000"
      persistent
    >
      <v-card>
        <v-container class="pa-4">
          <v-row justify="end">
            <v-btn
              icon
              color="accent"
              @click="$store.dispatch('Util/hideAuthLoginDialog')"
            >
              <v-icon x-large>mdi-close</v-icon>
            </v-btn>
          </v-row>
          <v-row>
            <!-- Register Column -->
            <v-col>
              <v-row justify="center" class="mb-12">
                <h4>{{ $t("texts.register") }}</h4>
              </v-row>

              <v-row class="mx-12" justify="center">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      class="primary"
                      x-large
                      block
                      @click.stop="
                        $store.dispatch('Util/showAuthVolunteerRegisterDialog')
                      "
                      v-bind="attrs"
                      v-on="on"
                      >{{ $t("texts.volunteer") }}
                    </v-btn>
                  </template>
                  <span>{{ $t("texts.wantbevolunteer") }}</span>
                </v-tooltip>
              </v-row>
              <v-row class="mx-12 mt-12" justify="center">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      class="primary"
                      x-large
                      block
                      @click.stop="
                        $store.dispatch('Util/showAuthEntityRegisterDialog')
                      "
                      v-bind="attrs"
                      v-on="on"
                      >{{ $t("texts.entity") }}
                    </v-btn>
                  </template>
                  <span>{{ $t("texts.regiterentitytooltip") }}</span>
                </v-tooltip>
              </v-row>
            </v-col>
            <!-- !Register Column -->
            <v-divider class="thick d-none d-md-inline-flex" inset vertical />
            <!-- Login Column -->
            <v-col>
              <v-row justify="center" class="mb-10">
                <v-icon color="accent" left large>mdi-lock</v-icon>
                <h4>{{ $t("texts.logintitle") }}</h4>
              </v-row>
              <v-form @submit.prevent="login">
                <v-row class="mx-12">
                  <v-col cols="12">
                    <a-text-field
                      v-model="$v.formLoginEmail.$model"
                      :validator="$v.formLoginEmail"
                      type="email"
                      :label="$t('texts.email')"
                    />
                  </v-col>
                  <v-col cols="12">
                    <a-text-field
                      v-model="$v.formLoginPassword.$model"
                      :validator="$v.formLoginPassword"
                      type="password"
                      :label="$t('texts.password')"
                    />
                  </v-col>
                  <v-col cols="12">
                    <v-btn large block color="primary" type="submit">{{
                      $t("texts.login")
                    }}</v-btn>
                  </v-col>
                </v-row>
              </v-form>
              <v-row class="mx-sm-12 mt-2" align="center">
                <v-col cols="12">
                  <v-btn
                    text
                    x-small
                    block
                    color="primary"
                    @click="goToRecoverPassword()"
                    >{{ $t("texts.forgotpassword") }}</v-btn
                  >
                </v-col>
              </v-row>
            </v-col>
            <!-- !Login Column -->
          </v-row>
        </v-container>
      </v-card>
    </v-dialog>
    <!-- !Login/Register Dialog -->

    <!-- Volunteer Register Dialog -->
    <v-dialog
      v-model="$store.getters['Util/getAuthVolunteerRegisterDialog']"
      width="1200"
      persistent
    >
      <v-card>
        <v-container class="pa-4">
          <div class="d-flex flex-column-reverse flex-sm-row mx-2 mb-4">
            <div>
              <h4>{{ $t("texts.volunteerregister") }}</h4>
            </div>
            <div class="ml-auto">
              <v-btn
                icon
                color="accent"
                @click="$store.dispatch('Util/hideAuthVolunteerRegisterDialog')"
              >
                <v-icon x-large>mdi-close</v-icon>
              </v-btn>
            </div>
          </div>

          <v-form @submit.prevent="registerVolunteer" class="mx-4">
            <v-row>
              <v-col cols="12" lg="6" class="form-layout">
                <a-text-field
                  v-model="$v.formVolunteerRegisterName.$model"
                  :validator="$v.formVolunteerRegisterName"
                  :rules="[
                    () =>
                      formVolunteerRegisterName.length > 0 ||
                      'Este campo é obrigatório'
                  ]"
                  :label="$t('texts.name') + '\u00A0' + $t('texts.required')"
                  required
                />
                <a-text-field
                  v-model="$v.formVolunteerRegisterEmail.$model"
                  :validator="$v.formVolunteerRegisterEmail"
                  type="email"
                  :label="$t('texts.email') + '\u00A0' + $t('texts.required')"
                />
                <a-date-field-menu
                  v-model="$v.formVolunteerRegisterBirthdate.$model"
                  :validator="$v.formVolunteerRegisterBirthdate"
                  :label="
                    $t('texts.birthdate') + '\u00A0' + $t('texts.required')
                  "
                  prependIcon="mdi-calendar-month"
                  birthdate
                ></a-date-field-menu>
                <div>
                  <a-select
                    v-model="$v.formVolunteerRegisterMotivations.$model"
                    :validator="$v.formVolunteerRegisterMotivations"
                    :items="volunteerMotivations"
                    :label="
                      $t('texts.volunteermotivationsinput') +
                        '\u00A0' +
                        $t('texts.required')
                    "
                    multiple
                  />
                  <a-text-field
                    v-model="formVolunteerRegisterMotivationsOther"
                    v-show="
                      formVolunteerRegisterMotivations &&
                        formVolunteerRegisterMotivations.includes(1)
                    "
                    class="mt-3"
                    :label="$t('texts.othervolunteermotivation')"
                  />
                </div>
                <a-text-field
                  v-model="$v.formVolunteerRegisterSchoolId.$model"
                  :validator="$v.formVolunteerRegisterSchoolId"
                  :label="$t('texts.perfilSchoolServices').replace(':', '')"
                />
                <a-textarea
                  v-model="formVolunteerRegisterObservations"
                  :label="$t('texts.observations')"
                />
              </v-col>
              <v-col cols="12" lg="6" class="form-layout">
                <a-text-field
                  v-model="$v.formVolunteerRegisterContact.$model"
                  :validator="$v.formVolunteerRegisterContact"
                  type="tel"
                  :label="
                    $t('texts.phonecontact') + '\u00A0' + $t('texts.required')
                  "
                />
                <a-text-field
                  v-model="$v.formVolunteerRegisterPassword.$model"
                  :validator="$v.formVolunteerRegisterPassword"
                  type="password"
                  :label="
                    $t('texts.password') + '\u00A0' + $t('texts.required')
                  "
                />
                <a-text-field
                  v-model="$v.formVolunteerRegisterConfirmPassword.$model"
                  :validator="$v.formVolunteerRegisterConfirmPassword"
                  type="password"
                  :label="
                    $t('texts.confirmpassword') +
                      '\u00A0' +
                      $t('texts.required')
                  "
                />
                <a-select
                  v-model="formVolunteerRegisterInterestAreasId"
                  :items="volunteerAreasOfInterest"
                  :label="$t('texts.perfilAreasOfInterest')"
                  multiple
                />
                <a-text-field
                  v-model="$v.formVolunteerRegisterCourse.$model"
                  :validator="$v.formVolunteerRegisterCourse"
                  :label="$t('texts.perfilCourseFormation').replace(':', '')"
                />
                <div>
                  <p>
                    {{
                      $t("texts.ipscommunitymember") +
                        "\u00A0" +
                        $t("texts.required")
                    }}
                  </p>
                  <v-radio-group
                    v-model="formVolunteerRegisterIpsCommunityMember"
                    mandatory
                    hide-details="auto"
                  >
                    <v-radio :label="$t('texts.student')" :value="1"></v-radio>
                    <v-radio :label="$t('texts.graduate')" :value="2"></v-radio>
                    <v-radio :label="$t('texts.teacher')" :value="3"></v-radio>
                    <v-radio
                      :label="$t('texts.nonTeacher')"
                      :value="4"
                    ></v-radio>
                    <div>
                      <v-radio :label="$t('texts.other')" :value="5"></v-radio>
                      <a-text-field
                        v-if="formVolunteerRegisterIpsCommunityMember === 5"
                        v-model="
                          $v.formVolunteerRegisterIpsCommunityMemberDescription
                            .$model
                        "
                        :validator="
                          $v.formVolunteerRegisterIpsCommunityMemberDescription
                        "
                      />
                    </div>
                  </v-radio-group>
                </div>
              </v-col>
            </v-row>

            <!-- Documento regulamento do voluntário IPS -->
            <v-row>
              <v-col cols="12">
                <p>
                  {{ $t("texts.ipsvolunteerregulation") }}
                  <i>
                    {{ $t("texts.brieflyavailable") }}
                  </i>
                </p>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12">
                <p>
                  {{
                    $t("texts.rgpdauthorization") +
                      "\u00A0" +
                      $t("texts.required")
                  }}
                </p>
                <div class="d-flex">
                  <a-checkbox v-model="formVolunteerRegisterRGPD"></a-checkbox>
                  <p v-html="$t('texts.rgpdconsent')" />
                </div>
              </v-col>
            </v-row>

            <div
              class="d-flex flex-column-reverse flex-sm-row align-center justify-end"
            >
              <div class="mt-2 mb-2 mt-sm-4 mb-sm-2 mr-sm-4">
                <v-btn
                  large
                  color="primary--text"
                  @click="
                    $store.dispatch('Util/hideAuthVolunteerRegisterDialog')
                  "
                >
                  {{ $t("texts.cancel") }}
                </v-btn>
              </div>
              <div class="mt-4 mb-2 mt-sm-4 mb-sm-2 ml-sm-4">
                <v-btn large color="primary" type="submit">{{
                  $t("texts.register")
                }}</v-btn>
              </div>
            </div>
          </v-form>
        </v-container>
      </v-card>
    </v-dialog>
    <!-- !Volunteer Register Dialog -->

    <!-- Entity Register Dialog -->
    <v-dialog
      v-model="$store.getters['Util/getAuthEntityRegisterDialog']"
      width="1200"
      persistent
    >
      <v-card>
        <v-container class="pa-4">
          <div class="d-flex flex-column-reverse flex-sm-row mx-2 mb-4">
            <div>
              <h4>{{ $t("texts.entityregister") }}</h4>
            </div>
            <div class="ml-auto">
              <v-btn
                icon
                color="accent"
                @click="$store.dispatch('Util/hideAuthEntityRegisterDialog')"
              >
                <v-icon x-large>mdi-close</v-icon>
              </v-btn>
            </div>
          </div>

          <v-form @submit.prevent="registerEntity" class="mx-4">
            <v-row>
              <v-col cols="12" lg="6" class="form-layout">
                <a-text-field
                  v-model="$v.formEntityRegisterName.$model"
                  :validator="$v.formEntityRegisterName"
                  :label="
                    $t('texts.organizationname') +
                      '\u00A0' +
                      $t('texts.required')
                  "
                />
                <a-text-field
                  v-model="$v.formEntityRegisterNamePerson.$model"
                  :validator="$v.formEntityRegisterNamePerson"
                  :label="
                    $t('texts.namePerson') + '\u00A0' + $t('texts.required')
                  "
                />
                <a-text-field
                  v-model="$v.formEntityRegisterEmail.$model"
                  :validator="$v.formEntityRegisterEmail"
                  type="email"
                  :label="$t('texts.email') + '\u00A0' + $t('texts.required')"
                />

                <a-text-field
                  v-model="$v.formVolunteerRegisterContact.$model"
                  :validator="$v.formVolunteerRegisterContact"
                  type="tel"
                  :label="
                    $t('texts.numberPhone') + '\u00A0' + $t('texts.required')
                  "
                />

                <a-textarea
                  v-model="formEntityRegisterObservations"
                  :label="$t('texts.observations')"
                />
              </v-col>
              <v-col cols="12" lg="6" class="form-layout">
                <a-text-field
                  v-model="$v.formEntityRegisterPassword.$model"
                  :validator="$v.formEntityRegisterPassword"
                  type="password"
                  :label="
                    $t('texts.password') + '\u00A0' + $t('texts.required')
                  "
                />
                <a-text-field
                  v-model="$v.formEntityRegisterConfirmPassword.$model"
                  :validator="$v.formEntityRegisterConfirmPassword"
                  type="password"
                  :label="
                    $t('texts.confirmpassword') +
                      '\u00A0' +
                      $t('texts.required')
                  "
                />
                <div>
                  <p>
                    {{
                      $t("texts.entitytype") + "\u00A0" + $t("texts.required")
                    }}
                  </p>
                  <v-radio-group
                    v-model="formEntityRegisterType"
                    mandatory
                    hide-details="auto"
                  >
                    <v-radio :label="$t('texts.internal')" value="2"></v-radio>
                    <v-radio :label="$t('texts.external')" value="3"></v-radio>
                  </v-radio-group>
                </div>
                <v-file-input
                  v-model="formEntityRegisterLogo"
                  v-show="formEntityRegisterType === '3'"
                  accept="image/jpeg"
                  show-size
                  :label="$t('texts.logoinput')"
                  hide-details="auto"
                ></v-file-input>
              </v-col>
            </v-row>
            <!-- Documento regulamento do voluntário IPS -->
            <v-row>
              <v-col cols="12">
                <p>
                  {{ $t("texts.ipsvolunteerregulation") }}
                  <i>
                    {{ $t("texts.brieflyavailable") }}
                  </i>
                </p>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12">
                <p>
                  {{
                    $t("texts.rgpdauthorization") +
                      "\u00A0" +
                      $t("texts.required")
                  }}
                </p>
                <div class="d-flex">
                  <a-checkbox v-model="formEntityRegisterRGPD"></a-checkbox>
                  <p v-html="$t('texts.rgpdconsent')" />
                </div>
              </v-col>
            </v-row>
            <div
              class="d-flex flex-column-reverse flex-sm-row align-center justify-end"
            >
              <div class="mt-2 mb-2 mt-sm-4 mb-sm-2 mr-sm-4">
                <v-btn
                  large
                  color="primary--text"
                  @click="$store.dispatch('Util/hideAuthEntityRegisterDialog')"
                >
                  {{ $t("texts.cancel") }}
                </v-btn>
              </div>
              <div class="mt-4 mb-2 mt-sm-4 mb-sm-2 ml-sm-4">
                <v-btn large color="primary" type="submit">{{
                  $t("texts.register")
                }}</v-btn>
              </div>
            </div>
          </v-form>
        </v-container>
      </v-card>
    </v-dialog>
    <!-- !Entity Register Dialog -->

    <!-- Change Password Dialog -->
    <v-dialog
      v-model="$store.getters['Util/getChangePasswordDialog']"
      width="500"
      persistent
    >
      <v-card>
        <v-container class="pa-4">
          <div class="d-flex flex-column-reverse flex-sm-row mx-2 mb-4">
            <div>
              <h4>{{ $t("texts.changepassowrd") }}</h4>
            </div>
            <div class="ml-auto">
              <v-btn icon color="accent" @click="closeChangePasswordDialog">
                <v-icon x-large>mdi-close</v-icon>
              </v-btn>
            </div>
          </div>

          <v-form @submit.prevent="changePassword" class="mx-4">
            <v-row>
              <v-col cols="12" class="form-layout">
                <a-text-field
                  v-model="$v.formChangePasswordCurrent.$model"
                  :validator="$v.formChangePasswordCurrent"
                  type="password"
                  :label="
                    $t('texts.currentPassword') +
                      '\u00A0' +
                      $t('texts.required')
                  "
                />
                <a-text-field
                  v-model="$v.formChangePasswordNew.$model"
                  :validator="$v.formChangePasswordNew"
                  type="password"
                  :label="
                    $t('texts.newPassword') + '\u00A0' + $t('texts.required')
                  "
                />
                <a-text-field
                  v-model="$v.formChangePasswordNewConfirm.$model"
                  :validator="$v.formChangePasswordNewConfirm"
                  type="password"
                  :label="
                    $t('texts.confirmedNewPassword') +
                      '\u00A0' +
                      $t('texts.required')
                  "
                />
              </v-col>
            </v-row>

            <div
              class="d-flex flex-column-reverse flex-sm-row align-center justify-end"
            >
              <div class="mt-2 mb-2 mt-sm-4 mb-sm-2 mr-sm-4">
                <v-btn
                  large
                  color="primary--text"
                  @click="closeChangePasswordDialog"
                >
                  {{ $t("texts.cancel") }}
                </v-btn>
              </div>
              <div class="mt-4 mb-2 mt-sm-4 mb-sm-2 ml-sm-4">
                <v-btn large color="primary" type="submit">{{
                  $t("texts.change")
                }}</v-btn>
              </div>
            </div>
          </v-form>
        </v-container>
      </v-card>
    </v-dialog>
    <!-- !Change Password Dialog -->

    <!-- Alert Snackbar -->
    <v-snackbar
      v-bind:value="$store.getters['Alert/status']"
      :color="$store.getters['Alert/color']"
      multi-line
      top
      @input="$store.dispatch('Alert/close')"
    >
      {{ $store.getters["Alert/text"] }}
      <v-btn text icon x-small @click="$store.dispatch('Alert/close')">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-snackbar>
    <!-- !Alert Snackbar -->

    <!-- Loading Overlay -->
    <v-overlay
      z-index="999"
      class="loader"
      :value="this.$store.getters['Util/isLoading']"
    >
      <v-progress-circular
        indeterminate
        size="64"
        color="primary"
      ></v-progress-circular>
    </v-overlay>
    <!-- !Loading Overlay -->
  </v-app>
</template>

<style scoped lang="sass">
.bar-z-top
  z-index: 100 !important

.mobile-navigation-menu
  padding-top: 80px

.language
  width: 40px

.v-btn
  &.btn-active
    color: var(--v-primary-base)
    border-bottom: 3px solid var(--v-primary-base)

    &::before
      opacity: 0

.v-footer
  &.a-footer
    height: $footer-height
    border-top-style: solid
    border-top-width: 4px
    border-color: var(--v-primary-base) !important
</style>

<script>
// @ is an alias to /src
import AppError from "@/utils/AppError.js";
import ATextField from "@/components/fields/ATextField.vue";
import ATextarea from "@/components/fields/ATextarea.vue";
import ACheckbox from "@/components/fields/ACheckbox.vue";
import ADateFieldMenu from "@/components/fields/ADateFieldMenu.vue";
import ASelect from "@/components/fields/ASelect.vue";

import { loadLanguageAsync } from "@/plugins/i18n";
import { validationMixin } from "vuelidate";
import {
  required,
  email,
  sameAs,
  requiredIf,
  maxLength,
  minLength
} from "vuelidate/lib/validators";
import { password, ipsdomain, onlyLettersSpaces } from "@/validators";
import { tel } from "@/validators";
import moment from "moment";

export default {
  components: {
    ATextField,
    ATextarea,
    ACheckbox,
    ADateFieldMenu,
    ASelect
  },

  mounted() {
    // Set language from local storage
    this.selectedLanguage =
      localStorage.getItem("language") ||
      navigator.language.split("-")[0] ||
      navigator.userLanguage.split("-")[0] ||
      "pt";

    moment.locale(this.selectedLanguage);
    moment.updateLocale("pt", {
      relativeTime: {
        future: "%s",
        past: "%s",
        s: "segundos",
        ss: "%d segundos",
        m: "um minuto",
        mm: "%d minutos",
        h: "uma hora",
        hh: "%d horas",
        d: "um dia",
        dd: "%d dias",
        M: "um mês",
        MM: "%d meses",
        y: "um ano",
        yy: "%d anos"
      }
    });
  },
  mixins: [validationMixin],

  validations: {
    // Login form validations
    formLoginEmail: { required, email },
    formLoginPassword: { required },

    // Volunteer register formm validations
    formVolunteerRegisterName: { required },
    formVolunteerRegisterEmail: { required, email, ipsdomain },
    formVolunteerRegisterBirthdate: { required },
    formVolunteerRegisterPassword: { required, password },
    formVolunteerRegisterConfirmPassword: {
      required,
      sameAsPassword: sameAs("formVolunteerRegisterPassword")
    },
    formVolunteerRegisterMotivations: { required },
    formVolunteerRegisterInterestAreasId: { required },
    formVolunteerRegisterCourse: { minLength: minLength(4) },
    formVolunteerRegisterSchoolId: { minLength: minLength(4) },
    formVolunteerRegisterContact: { tel, required },
    formVolunteerRegisterIpsCommunityMember: { required },
    formVolunteerRegisterIpsCommunityMemberDescription: {
      required: requiredIf(function() {
        return this.formVolunteerRegisterIpsCommunityMember === 5;
      }),
      maxLength: maxLength(50),
      onlyLettersSpaces
    },

    // Entity register form validations
    formEntityRegisterNamePerson: { required },
    formEntityRegisterName: { required },
    formEntityRegisterEmail: { required, email },
    formEntityRegisterPassword: { required, password },
    formEntityRegisterConfirmPassword: {
      required,
      sameAsPassword: sameAs("formEntityRegisterPassword")
    },

    // Change password form validations
    formChangePasswordCurrent: { required },
    formChangePasswordNew: { required, password },
    formChangePasswordNewConfirm: {
      sameAsPassword: sameAs("formChangePasswordNew")
    }
  },

  data() {
    return {
      // Navigation drawer
      drawer: false,

      // Selected language
      selectedLanguage: null,

      // Login form data
      formLoginEmail: null,
      formLoginPassword: null,

      // Volunteer register form data
      formVolunteerRegisterName: null,
      formVolunteerRegisterEmail: null,
      formVolunteerRegisterBirthdate: null,
      formVolunteerRegisterObservations: null,
      formVolunteerRegisterContact: null,
      formVolunteerRegisterPassword: null,
      formVolunteerRegisterConfirmPassword: null,
      formVolunteerRegisterMotivations: null,
      formVolunteerRegisterInterestAreasId: null,
      formVolunteerRegisterCourse: null,
      formVolunteerRegisterSchoolId: null,
      formVolunteerRegisterMotivationsOther: null,
      formVolunteerRegisterIpsCommunityMember: null,
      formVolunteerRegisterIpsCommunityMemberDescription: null,
      formVolunteerRegisterRGPD: null,

      // Entity register form data
      formEntityRegisterNamePerson: null,
      formEntityRegisterName: null,
      formEntityRegisterEmail: null,
      formEntityRegisterObservations: null,
      formEntityRegisterPassword: null,
      formEntityRegisterConfirmPassword: null,
      formEntityRegisterType: null,
      formEntityRegisterLogo: null,
      formEntityRegisterRGPD: null,

      // Change password form data
      formChangePasswordCurrent: null,
      formChangePasswordNew: null,
      formChangePasswordNewConfirm: null
    };
  },

  methods: {
    /**
     * Login in the app.
     */
    login() {
      this.$v.formLoginEmail.$touch();
      this.$v.formLoginPassword.$touch();
      if (
        this.$v.formLoginEmail.$invalid ||
        this.$v.formLoginPassword.$invalid
      ) {
        return;
      }

      this.$store
        .dispatch("Auth/login", {
          email: this.formLoginEmail,
          password: this.formLoginPassword
        })
        .then(() => {
          this.$store.dispatch(
            "Alert/showSuccess",
            this.$t("texts.loginsuccess")
          );
          this.$store.dispatch("Util/hideAuthLoginDialog");

          // Reset fields and validations
          this.formLoginEmail = null;
          this.formLoginPassword = null;
          this.$v.formLoginEmail.$reset();
          this.$v.formLoginPassword.$reset();
        })
        .catch(err => {
          AppError.handle(err);
        });
    },

    /**
     * Regist a volunteer in the app.
     */
    registerVolunteer() {
      this.$v.formVolunteerRegisterName.$touch();
      this.$v.formVolunteerRegisterEmail.$touch();
      this.$v.formVolunteerRegisterContact.$touch();
      this.$v.formVolunteerRegisterBirthdate.$touch();
      this.$v.formVolunteerRegisterPassword.$touch();
      this.$v.formVolunteerRegisterConfirmPassword.$touch();
      this.$v.formVolunteerRegisterMotivations.$touch();
      this.$v.formVolunteerRegisterCourse.$touch();
      this.$v.formVolunteerRegisterSchoolId.$touch();
      this.$v.formVolunteerRegisterIpsCommunityMember.$touch();
      this.$v.formVolunteerRegisterIpsCommunityMemberDescription.$touch();
      if (
        this.$v.formVolunteerRegisterName.$invalid ||
        this.$v.formVolunteerRegisterEmail.$invalid ||
        this.$v.formVolunteerRegisterContact.$invalid ||
        this.$v.formVolunteerRegisterBirthdate.$invalid ||
        this.$v.formVolunteerRegisterPassword.$invalid ||
        this.$v.formVolunteerRegisterConfirmPassword.$invalid ||
        this.$v.formVolunteerRegisterMotivations.$invalid ||
        this.$v.formVolunteerRegisterCourse.$invalid ||
        this.$v.formVolunteerRegisterSchoolId.$invalid ||
        this.$v.formVolunteerRegisterIpsCommunityMember.$invalid ||
        this.$v.formVolunteerRegisterIpsCommunityMemberDescription.$invalid
      ) {
        return;
      }

      if (!this.formVolunteerRegisterRGPD) {
        this.$store.dispatch("Alert/showError", this.$t("errors.ACCEPT_RGPD"));
        return;
      }

      this.$store
        .dispatch("Auth/registerVolunteer", {
          email: this.formVolunteerRegisterEmail,
          password: this.formVolunteerRegisterPassword,
          name: this.formVolunteerRegisterName,
          comments: this.formVolunteerRegisterObservations,
          mobileNumber: this.formVolunteerRegisterContact,
          birthdate: this.formVolunteerRegisterBirthdate,
          motivations: this.formVolunteerRegisterMotivations,
          interestAreadIds: this.formVolunteerRegisterInterestAreasId,
          course: this.formVolunteerRegisterCourse,
          schoolId: this.formVolunteerRegisterSchoolId,
          motivationOther: this.formVolunteerRegisterMotivationsOther,
          ipsCommunityMember: this.formVolunteerRegisterIpsCommunityMember,
          ipsCommunityMemberDescription: this
            .formVolunteerRegisterIpsCommunityMemberDescription
        })
        .then(() => {
          this.$store.dispatch(
            "Alert/showSuccess",
            this.$t("texts.userRegisterSuccess")
          );
          this.$store.dispatch("Util/hideAuthVolunteerRegisterDialog");
          this.$store.dispatch("Util/showAuthLoginDialog");

          // Reset fields and validations
          this.formVolunteerRegisterEmail = null;
          this.formVolunteerRegisterPassword = null;
          this.formVolunteerRegisterConfirmPassword = null;
          this.formVolunteerRegisterName = null;
          this.formVolunteerRegisterObservations = null;
          this.formVolunteerRegisterContact = null;
          this.formVolunteerRegisterBirthdate = null;
          this.formVolunteerRegisterInterestAreasId = null;
          this.formVolunteerRegisterCourse = null;
          this.formVolunteerRegisterSchoolId = null;
          this.formVolunteerRegisterMotivations = null;
          this.formVolunteerRegisterMotivationsOther = null;
          this.formVolunteerRegisterIpsCommunityMember = null;
          this.formVolunteerRegisterIpsCommunityMemberDescription = null;
          this.formVolunteerRegisterRGPD = null;
          this.$v.formVolunteerRegisterName.$reset();
          this.$v.formVolunteerRegisterEmail.$reset();
          this.$v.formVolunteerRegisterContact.$reset();
          this.$v.formVolunteerRegisterBirthdate.$reset();
          this.$v.formVolunteerRegisterPassword.$reset();
          this.$v.formVolunteerRegisterConfirmPassword.$reset();
          this.$v.formVolunteerRegisterMotivations.$reset();
          this.$v.formVolunteerRegisterCourse.$reset();
          this.$v.formVolunteerRegisterSchoolId.$reset();
          this.$v.formVolunteerRegisterIpsCommunityMember.$reset();
          this.$v.formVolunteerRegisterIpsCommunityMemberDescription.$reset();
        })
        .catch(err => {
          AppError.handle(err);
        });
    },

    /**
     * Regist a entity in the app.
     */
    registerEntity() {
      this.$v.formEntityRegisterName.$touch();
      this.$v.formEntityRegisterEmail.$touch();
      this.$v.formEntityRegisterPassword.$touch();
      this.$v.formEntityRegisterConfirmPassword.$touch();
      this.$v.formEntityRegisterNamePerson.$touch();
      this.$v.formVolunteerRegisterContact.$touch();
      if (
        this.$v.formEntityRegisterName.$invalid ||
        this.$v.formEntityRegisterEmail.$invalid ||
        this.$v.formEntityRegisterPassword.$invalid ||
        this.$v.formEntityRegisterConfirmPassword.$invalid ||
        this.$v.formEntityRegisterNamePerson.$invalid ||
        this.$v.formVolunteerRegisterContact.$invalid
      ) {
        return;
      }

      if (!this.formEntityRegisterRGPD) {
        this.$store.dispatch("Alert/showError", this.$t("errors.ACCEPT_RGPD"));
        return;
      }

      if (
        this.formEntityRegisterLogo &&
        this.formEntityRegisterLogo.size / 1024 / 1024 > 1
      ) {
        this.$store.dispatch(
          "Alert/showError",
          this.$t("errors.INVALID_FIELD_CAUSE", {
            field: this.$t("texts.logoinput"),
            cause: this.$t("texts.filetoolarge", { size: 1 })
          })
        );
        return;
      }

      this.$store
        .dispatch("Auth/registerEntity", {
          email: this.formEntityRegisterEmail,
          password: this.formEntityRegisterPassword,
          type: this.formEntityRegisterType,
          name: this.formEntityRegisterName,
          mobileNumber: this.formVolunteerRegisterContact,
          comments: this.formEntityRegisterObservations,
          logo: this.formEntityRegisterLogo,
          namePerson: this.formEntityRegisterNamePerson
        })
        .then(() => {
          this.$store.dispatch(
            "Alert/showSuccess",
            this.$t("texts.userRegisterSuccess")
          );
          this.$store.dispatch("Util/hideAuthEntityRegisterDialog");
          this.$store.dispatch("Util/showAuthLoginDialog");

          // Reset fields and validations
          this.formEntityRegisterEmail = null;
          this.formEntityRegisterPassword = null;
          this.formEntityRegisterConfirmPassword = null;
          this.formEntityRegisterType = null;
          this.formEntityRegisterName = null;
          this.formEntityRegisterObservations = null;
          this.formEntityRegisterLogo = null;
          this.formEntityRegisterRGPD = null;
          this.$v.formEntityRegisterEmail.$reset();
          this.$v.formEntityRegisterPassword.$reset();
          this.$v.formEntityRegisterConfirmPassword.$reset();
          this.$v.formEntityRegisterName.$reset();
          this.$v.formEntityRegisterNamePerson.$reset();
          this.$v.formVolunteerRegisterContact.$reset();
        })
        .catch(err => {
          AppError.handle(err);
        });
    },

    /**
     * Change the user's password.
     */
    changePassword() {
      this.$v.formChangePasswordCurrent.$touch();
      this.$v.formChangePasswordNew.$touch();
      this.$v.formChangePasswordNewConfirm.$touch();
      if (
        this.$v.formChangePasswordCurrent.$invalid ||
        this.$v.formChangePasswordNew.$invalid ||
        this.$v.formChangePasswordNew.$invalid
      ) {
        return;
      }

      this.$store
        .dispatch("Auth/changePassword", {
          currentPassword: this.formChangePasswordCurrent,
          newPassword: this.formChangePasswordNew
        })
        .then(() => {
          this.$store.dispatch(
            "Alert/showSuccess",
            this.$t("texts.passwordchanged")
          );
          this.closeChangePasswordDialog();
        })
        .catch(err => {
          AppError.handle(err);
        });
    },

    /**
     * Redirect to recover password screen.
     */
    goToRecoverPassword() {
      this.$store.dispatch("Util/hideAuthLoginDialog");
      this.$router.push({ name: "RecoverPassword" });
    },

    /**
     * Redirect to backoffice.
     */
    goToBackoffice() {
      window.location.href = "/backoffice/";
    },

    /**
     * Close the change password dialog.
     */
    closeChangePasswordDialog() {
      this.$store.dispatch("Util/hideChangePasswordDialog");

      // Reset fields and validations
      this.formChangePasswordCurrent = null;
      this.formChangePasswordNew = null;
      this.formChangePasswordNewConfirm = null;
      this.$v.formChangePasswordCurrent.$reset();
      this.$v.formChangePasswordNew.$reset();
      this.$v.formChangePasswordNewConfirm.$reset();
    },

    /**
     * Logout the app.
     */
    logout() {
      this.$store.dispatch("Auth/logout").then(() => {
        this.$router.push({ name: "Home" });
      });
    }
  },

  computed: {
    // Volunteer motivations
    volunteerMotivations() {
      return [
        {
          value: 2,
          text: this.$t("texts.volunteermotivations.2")
        },
        {
          value: 3,
          text: this.$t("texts.volunteermotivations.3")
        },
        {
          value: 5,
          text: this.$t("texts.volunteermotivations.5")
        },
        {
          value: 6,
          text: this.$t("texts.volunteermotivations.6")
        },
        {
          value: 7,
          text: this.$t("texts.volunteermotivations.7")
        },
        {
          value: 8,
          text: this.$t("texts.volunteermotivations.8")
        },
        {
          value: 9,
          text: this.$t("texts.volunteermotivations.9")
        },
        {
          value: 10,
          text: this.$t("texts.volunteermotivations.10")
        },
        {
          value: 1,
          text: this.$t("texts.other")
        }
      ];
    },

    // Volunteer areas of interest
    volunteerAreasOfInterest() {
      return [
        {
          value: 1,
          text: this.$t("texts.volunteerareasofinterest.1")
        },
        {
          value: 2,
          text: this.$t("texts.volunteerareasofinterest.2")
        },
        {
          value: 3,
          text: this.$t("texts.volunteerareasofinterest.3")
        },
        {
          value: 4,
          text: this.$t("texts.volunteerareasofinterest.4")
        },
        {
          value: 5,
          text: this.$t("texts.volunteerareasofinterest.5")
        },
        {
          value: 6,
          text: this.$t("texts.volunteerareasofinterest.6")
        },
        {
          value: 7,
          text: this.$t("texts.volunteerareasofinterest.7")
        },
        {
          value: 8,
          text: this.$t("texts.volunteerareasofinterest.8")
        }
      ];
    },

    // Available languages
    availableLanguages() {
      return [
        {
          value: "pt",
          text: this.$t("texts.languages.portuguese")
        },
        {
          value: "en",
          text: this.$t("texts.languages.english")
        }
      ];
    }
  },

  watch: {
    selectedLanguage() {
      localStorage.setItem("language", this.selectedLanguage);

      // Set app language
      loadLanguageAsync(this.selectedLanguage);
    }
  }
};
</script>
